
// This script is designed to be used with the ICMIB survey. It will capture
// real-time data from the user as they type into the open text fields. The
// data will be stored in hidden input fields and submitted with the form.
// The data will be stored in the following format:
// {
//   "questionId": [
//     {
//       "outputValue": "A1B2C3D4E5F6G7H8I9J10",
//       "value": "User input value"
//     },
//     {
//       "outputValue": "A1B2C3D4E5F6G7H8I9J10",
//       "value": "User input value"
//     },
//  ...
//   ]
// }

class RealTimeDataValidator {
  constructor() {
    this.questionIdHasManyMetadata = {
      questionId: "",
      metadata: []
    };
    this.metadata = {
      questionId: "",
      inputDomElement: null,
      firstChar: true,
      numberOfCharactersTyped: 0,
      maxPasteLength: 0,
      autoCompleteDetected: 0,
      numberOfKeyUpCountAll: 0,
      numberOfKeyDownCountAll: 0,
      pastedEntireResponse: 0,
      speechDetected: 0,
      startTime: null,
      timeDiff: 0,
      endTime: null,
      startTimeChar: null,
      timeDiffFirstChar: 0,
      outputString: function () {
        return `${this.randomCharacter()}${this.numberOfKeyDownCountAll}` +
               `${this.randomCharacter()}${this.numberOfKeyUpCountAll}` +
               `${this.randomCharacter()}${this.timeDiff}` +
               `${this.randomCharacter()}${this.timeDiffFirstChar}` +
               `${this.randomCharacter()}${this.maxPasteLength}` +
               `${this.randomCharacter()}${this.autoCompleteDetected}` +
               `${this.randomCharacter()}${this.speechDetected}` +
               `${this.randomCharacter()}${this.pastedEntireResponse}` +
               `${this.randomCharacter()}${this.inputDomElement.value.length}`;
      },
      randomCharacter: function () {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        return characters.charAt(Math.floor(Math.random() * characters.length));
      }
    };
  }

  preloadMetaData() {
    const metadataArray = [];

    document.querySelectorAll('.Survey\\:\\:Open').forEach(container => {
      // the id looks like question_67a69032413b1900092572fd
      const questionId = container.getAttribute('id').split('_')[1];

      container.querySelectorAll('textarea[name^="questions[open"]').forEach(inputField => {
        const meta = Object.create(this.metadata);
        meta.questionId = questionId;
        meta.inputDomElement = inputField;
        metadataArray.push(meta);
      });
    });
    return metadataArray;
  }

  populateQuestionIdHasManyMetadata(metadataArray) {
    const hasManyMetaDatas = [];
    // get the unique question ids from the metadataArray
    const questionIds = metadataArray.map(meta => meta.questionId);
    // remove duplicates
    const uniqueQuestionIds = [...new Set(questionIds)];
    // now iterate over the unique question ids
    uniqueQuestionIds.forEach(questionId => {
      // create a new questionIdHasManyMetadata object
      const questionIdHasManyMetadata = Object.create(this.questionIdHasManyMetadata);
      questionIdHasManyMetadata.questionId = questionId;

      const metadataForQuestion = metadataArray.filter(meta => meta.questionId === questionId);
      // now iterate over the metadata for this question
      metadataForQuestion.forEach(meta => {
        // Calculate final timing values if not already set
        if (meta.endTime === null && meta.startTime !== null) {
          meta.endTime = new Date();
          meta.timeDiff = meta.endTime - meta.startTime;
          meta.timeDiffFirstChar = meta.startTimeChar ? meta.endTime - meta.startTimeChar : 0;
        }

        const inputLength = meta.inputDomElement.value.length;
        if (inputLength === meta.maxPasteLength) {
          meta.pastedEntireResponse = 1;
        }
        questionIdHasManyMetadata.metadata.push({outputValue: meta.outputString(), value: meta.inputDomElement.value});
      });
      hasManyMetaDatas.push(questionIdHasManyMetadata);
    });

    return hasManyMetaDatas;
  }

  handleMetadataOnFormSubmit(metadataArray) {
    // should only be one form per page
    //
    const formElement = document.querySelector('form');
    if (!formElement) {
      return;
    }

    formElement.addEventListener('submit', (_event) => {
      const allMetadata = this.populateQuestionIdHasManyMetadata(metadataArray);

      allMetadata.forEach(meta => {
        const hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', `metadata[${meta.questionId}]`);
        hiddenInput.setAttribute('value', JSON.stringify(meta.metadata));
        formElement.appendChild(hiddenInput);
      });
    });
  }

  addEventListeners(meta) {
    meta.inputDomElement.addEventListener('keyup', function (event) {
      meta.numberOfKeyUpCountAll++;
    });

    meta.inputDomElement.addEventListener('keydown', function (event) {
      if (meta.firstChar) {
        meta.firstChar = false;
        meta.startTimeChar = new Date();
      }
      meta.numberOfKeyDownCountAll++;
    });

    meta.inputDomElement.addEventListener('focus', function (event) {
      if (meta.startTime === null) {
        meta.startTime = new Date();
      }
    });

    meta.inputDomElement.addEventListener('blur', function (event) {
      meta.endTime = new Date();
      meta.timeDiff = meta.endTime - meta.startTime;
      meta.timeDiffFirstChar = meta.endTime - meta.startTimeChar;
    });

    meta.inputDomElement.addEventListener('input', function (event) {
      //Flagging assistive technology
      if (
        event.inputType === "insertText" &&
        event.data.split(" ").length - 1 > 1
      ) {
        meta.autoCompleteDetected = 1;
      } else if (
        event.inputType === "insertReplacementText" ||
        (event.data && event.data.length > 1 && event.inputType === "insertText")
      ) {
        autoCompleteDetected = 1;
      }
      //Flagging speech to text
      if (event.inputType === "insertCompositionText") {
        if ( event.data.split(" ").length > 1 ) {
          meta.speechDetected = 1;
        };
      };
      //Adjust paste length on paste
      if (event.inputType === "insertFromPaste") {
        if (event.data.length > meta.maxPasteLength) {
          meta.maxPasteLength = event.data.length;
        };
      };
    });
  }

  init() {
    const metadataArray = this.preloadMetaData();
    metadataArray.forEach(meta => this.addEventListeners(meta));
    this.handleMetadataOnFormSubmit(metadataArray);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const rtdv = new RealTimeDataValidator();
  setTimeout(() => {
    rtdv.init();
  }
  , 100);
});
